import { render, staticRenderFns } from "./UiFieldTextArea.vue?vue&type=template&id=4372f120"
import script from "./UiFieldTextArea.vue?vue&type=script&lang=js"
export * from "./UiFieldTextArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports